import React from "react";
import { TextField, Tooltip } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopTimePicker } from "@mui/x-date-pickers/DesktopTimePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { useClipsStore } from "./ClipsStore/clipsStore";
import { useNavigate } from "react-router-dom";
import {
  TIME_FILTERS_SAME_DATE_TOOLTIP,
  timeFiltersSameDateTooltipProps,
} from "../../common/timeFiltersSameDateTooltip";

export const StartTimeDropDownFrontel = () => {
  const {
    userFiltersFrontel,
    setUserFiltersFrontel,
    timeFiltersDisabledFrontel,
  } = useClipsStore();

  const navigate = useNavigate();

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Tooltip
        title={TIME_FILTERS_SAME_DATE_TOOLTIP}
        disableHoverListener={!timeFiltersDisabledFrontel}
        disableFocusListener={!timeFiltersDisabledFrontel}
        disableTouchListener={!timeFiltersDisabledFrontel}
        {...timeFiltersSameDateTooltipProps}
      >
        <span style={{ display: "inline-block" }}>
          <DesktopTimePicker
            label="Start Time"
            value={
              userFiltersFrontel.start_time ? userFiltersFrontel.start_time : null
            }
            onChange={(newValue) => {
              setUserFiltersFrontel((previousState: any) => ({
                ...previousState,
                start_time: newValue,
              }));
              // TODO: Add getDownloadURLFrontel call when API function is ready
              // getDownloadURLFrontel(navigate);
            }}
            disabled={timeFiltersDisabledFrontel}
            renderInput={(params) => (
              <TextField {...params} autoComplete="off" sx={{ width: 150 }} />
            )}
          />
        </span>
      </Tooltip>
    </LocalizationProvider>
  );
};
